<ion-header>
  <ion-toolbar>
    <ion-title>About</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="card">
    <div class='item item-text-wrap'>
      <p>Deze app wordt beschikbaar gesteld door Lipronics b.v.</p>
    </div>
    <div class='item item-text-wrap'>
        <table class="afstand">
            <tr>
                <td class="tag">Versie</td>
                <td class="tag">:</td>
                <td>{{global.Version}}</td>
            </tr>
            <tr *ngIf="(global.apkDownload || (global.compname=='im')) && (global.latestVersion > global.Version)">
                <td></td>
                <td></td>
                <td>
                    <a href='{{global.apkurl}}'>Update beschikbaar</a>
                </td>
            </tr>
            <tr>
                <td class="tag">User</td>
                <td class="tag">:</td>
                <td>{{global.compname}} - {{global.username}}</td>
            </tr>
            <tr>
                <td class="tag">Connection</td>
                <td class="tag">:</td>
                <td>{{global.uuid}}</td>
            </tr>
            <tr>
                <td class="tag">Device</td>
                <td class="tag">:</td>
                <td>{{global.devInfo}}</td>
            </tr>
        </table>
    </div>
  </div>
  <div class="card">
    <div class='item item-text-wrap'>
      <img src='./assets/lisaas.png' style="width:30%; padding:10px;" align='right'>
      <p>Lisaas is het ERP pakket voor project georienteerde bedrijven.
      Alle gegevens overzichtelijk beschikbaar via internet of app.
      Door de modulaire opzet is het pakket efficient af te stemmen op uw specifieke behoefte.</p>
    </div>
  </div>
  <ion-button size="large" expand="block" [routerLink]="['/home']">OK</ion-button>
</ion-content>
